import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
    return (
        <div className="not-found">
            <h3>PAGE NOT FOUND 404</h3>
            <span>
                <Link to="/">Return to Home Page?</Link>
            </span>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Not Found!</title>
            </Helmet>
        </div>
    );
};

export default NotFound;
